import { Pipe, PipeTransform } from '@angular/core';
import { filter, propEq } from 'ramda/es';

@Pipe({ name: 'linkActivated' })
export class linksPipe implements PipeTransform {
  transform(dropdowns: any[]): any {
    return dropdowns.filter(dropdown => dropdown.activate());
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/sidemenu/sidemenu.pipe.ts